import { Amenity } from '@tallo/property';

/**
 * Amenity keys that describe the building rather than one unit; the backend keeps the same list
 * for its push (plus the two courtyard flags the app never shows). A building's form offers only these.
 */
export const buildingAmenityKeys: readonly Amenity[] = [
  'hasBarbecueArea',
  'hasBasketBallCourt',
  'hasBusinessCenter',
  'hasChildCare',
  'hasClubDiscount',
  'hasConcierge',
  'hasControlledAccess',
  'hasCourtyard',
  'hasDisabledAccess',
  'hasDock',
  'hasDoorman',
  'hasElevator',
  'hasFencedYard',
  'hasFitnessCenter',
  'hasGarden',
  'hasGatedEntry',
  'hasGreenHouse',
  'hasHotTubSpa',
  'hasHouseKeeping',
  'hasIntercom',
  'hasLawn',
  'hasNightPatrol',
  'hasOnSiteMaintenance',
  'hasOnSiteManagement',
  'hasPackageReceiving',
  'hasPlayGround',
  'hasPong',
  'hasPool',
  'hasRaquetBallCourt',
  'hasSauna',
  'hasSecuritySystem',
  'hasSportsCourt',
  'hasSprinklerSystem',
  'hasSunDeck',
  'hasTennisCourt',
  'hasTVLounge',
  'hasVolleyBallCourt',
];
